import styled, { css } from "styled-components";

var ToggleMenuIcon = styled.div.withConfig({
  displayName: "ToggleMenuIcon",
  componentId: "sc-1rh98d0-0"
})(["display:inline-block;position:relative;width:1em;height:1em;&::before,&::after{content:\"\";position:absolute;background-color:currentColor;transition:0.25s ease-out;width:100%;height:20%;}&::before{top:15%;}&::after{top:65%;}", ";"], function (props) {
  return props.toggle && css(["&::before,&::after{top:40%;}&::before{transform:rotate(45deg);}&::after{transform:rotate(-45deg);}"]);
});

export default ToggleMenuIcon;